import { useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';
import SubRowContent from './RowContent';
import SectionTitle from '../../components/SectionTitle';

import {
  Box,
  Typography,
  InputAdornment,
  FormHelperText,
  Stack,
} from '@mui/material';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const BabyStatus = (props: Props) => {
  const { disabled, register, getValues, setValue, watch } = props;

  const contents = [
    {
      label: 'Giới tính',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.BABY_STATUS.GENDER"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.gender')}
          onChange={v => setValue('newborn_condition.gender', v)}
          width="100px"
        />
      ),
    },
    {
      label: 'Cân nặng',
      element: (
        <Form.MuiTextField
          placeholder="Cân nặng"
          InputProps={{
            endAdornment: <InputAdornment position="end">kg</InputAdornment>,
          }}
          required={false}
          disabled={disabled}
          {...register('newborn_condition.weight')}
        />
      ),
    },
    {
      label: 'Sự nạp ôxy',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.oxygen_intake')}
          onChange={v => setValue('newborn_condition.oxygen_intake', v)}
          width="100px"
        />
      ),
    },
    {
      label: 'nước tiểu\nđầu tiên',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.first_urine')}
          onChange={v => setValue('newborn_condition.first_urine', v)}
          width="100px"
        />
      ),
    },
    {
      label: 'Loại bỏ\nphân su',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.placenta_discharge')}
          onChange={v => setValue('newborn_condition.placenta_discharge', v)}
          width="100px"
        />
      ),
    },
    {
      label: 'Màu phân su',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.fetal_staining')}
          onChange={v => setValue('newborn_condition.fetal_staining', v)}
          width="100px"
        />
      ),
    },
    {
      label: 'Dây rốn',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.nuchal_cord')}
          onChange={v => {
            setValue('newborn_condition.nuchal_cord', v);
            if (v == 1) setValue('newborn_condition.nuchal_cord_content', '');
          }}
          width="100px"
        />
      ),
    },
    {
      label: 'Cấp cứu',
      element: (
        <Form.MuiRadioGroup
          disabled={disabled}
          i18nKey="CHILDBIRTH.YES_OR_NO"
          values={[1, 2]}
          defaultValue={getValues('newborn_condition.resuscitation')}
          onChange={v => {
            setValue('newborn_condition.resuscitation', v);
            if (v == 1) setValue('newborn_condition.resuscitation_content', '');
          }}
          width="100px"
        />
      ),
    },
    {
      label: 'Dị dạng và các đặc điểm chi tiết',
      element: (
        <Form.MuiTextField
          required={false}
          disabled={disabled}
          {...register('newborn_condition.specifications')}
        />
      ),
    },
  ];
  return (
    <>
      <SectionTitle title="Tình trạng trẻ sơ sinh" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => {
          if (label === 'Loại bỏ\nphân su') {
            return (
              <>
                <SubRowContent
                  title={label}
                  titleRatio={1.2}
                  childrenRatio={1.8}
                >
                  {element}
                </SubRowContent>
              </>
            );
          }
          return (
            <>
              <RowContent
                title={label}
                titleRatio={
                  label === 'Dị dạng và các đặc điểm chi tiết' ? 2 : 1.2
                }
                childrenRatio={
                  label === 'Dị dạng và các đặc điểm chi tiết' ? 10 : 1.8
                }
              >
                {element}
              </RowContent>
            </>
          );
        })}
      </RowContainer>
    </>
  );
};

export default BabyStatus;
